import React, { FC, useEffect } from 'react';
import { Container, TextField, InputLabel } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import styled from 'styled-components';
import { get, isEmpty } from 'lodash';
import { VictimType } from 'typings/globalTypes';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { filterVictim } from 'containers/CourtManagerLegalProceedings/utils';

export const StyledInputLabel = styled(InputLabel)`
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
  color: black;
  box-shadow: 0px 1px 3px #000;
  height: 36px;
  margin-right: 20px;
`;

export const StyledTextField = styled(TextField)`
  margin-left: 18px;
  margin-top: 6px;
`;
export interface ProvisionAmountFormProps {
  intl: IntlShape;
  judgementOnMerits: any;
  setContestationDecision: Function;
  contestationDecision: any;
  decisionDocumentToUpdate: any;
  contestationDocs: any;
  setContestationDocs: Function;
}

const ProvisionAmountForm: FC<ProvisionAmountFormProps> = props => {
  const [
    revenueVehiculeFormValues,
    setRevenueVehiculeFormValues,
  ] = React.useState<any>([]);
  useEffect(() => {
    let contDec: any = {};
    if (isEmpty(props.decisionDocumentToUpdate)) {
      props.judgementOnMerits.jom.jmc?.victims.forEach(({ id }: any) => {
        contDec = { ...contDec, ...{ [id]: { amount: '', victimId: id } } };
      });
      props.setContestationDecision(contDec);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.judgementOnMerits]);

  const onChangeVehicule = (
    e: React.ChangeEvent<{ value: unknown; name?: string }>,
    index: number,
  ) => {
    let newArr = [...revenueVehiculeFormValues];
    newArr[index] = e.target.value;
    setRevenueVehiculeFormValues(newArr);
  };
  const onChangeDecision = (_: any) => {
    if (!isEmpty(props.decisionDocumentToUpdate)) {
      const decisions = [...get(props.contestationDocs, 'dec', [])];

      const currentDecision =
        decisions.find(
          (item: any) => Number(item.victimId) === Number(_.target.id),
        ) || {};

      if (currentDecision) {
        decisions[decisions.indexOf(currentDecision)] = {
          ...currentDecision,
          victimId: Number(_.target.id),
          amount: _.target.value.replace(',', '.'),
        };

        props.setContestationDocs({
          ...props.contestationDocs,
          dec: decisions,
        });
      }
    }
    props.setContestationDecision({
      ...props.contestationDecision,
      ...{
        [_.target.id]: {
          amount: _.target.value.replace(',', '.'),
          victimId: Number(_.target.id),
        },
      },
    });
  };
  return (
    <Container>
      {props.judgementOnMerits.jom.jmc.against === 'Victime' ? (
        <div style={{ marginLeft: '-13px' }}>
          <InputLabel style={{ marginTop: '25px' }}>
            {translate(messages.contestationVictimes, props)}
          </InputLabel>
          {filterVictim(props.judgementOnMerits.jom.jmc?.victims)?.map(
            (victim: VictimType) => (
              <div
                key={victim.id}
                style={{ display: 'flex', flexDirection: 'initial' }}
              >
                <StyledInputLabel>
                  {`${victim.firstName} ${victim.lastName}`}
                </StyledInputLabel>
                <TextField
                  id={(victim.id as unknown) as string}
                  name="inputVictim"
                  type="number"
                  className="victim-amount"
                  value={get(
                    props.contestationDecision[
                      (victim.id as unknown) as number
                    ],
                    'amount',
                    '',
                  )}
                  label={translate(messages.newAmount, props)}
                  onChange={onChangeDecision}
                  style={{ marginBottom: '15px' }}
                />
              </div>
            ),
          )}
        </div>
      ) : (
        <>
          <StyledInputLabel style={{ marginTop: '25px' }}>
            {translate(messages.contestationOpposingParties, props)}
          </StyledInputLabel>
          {props.judgementOnMerits.jom.jmc?.vehicules?.map(
            (vehicule: any, index: number) => (
              <StyledTextField
                data-testid="input-vehicule-id"
                type="number"
                className="vehicule-amount"
                label={translate(messages.newAmount, props)}
                onChange={event => onChangeVehicule(event, index)}
                style={{ marginBottom: '15px' }}
              />
            ),
          )}
        </>
      )}
    </Container>
  );
};

export default injectIntl(ProvisionAmountForm);
